import { fetcherAmplify } from '../../Libraries/Fetcher';
import ContratRepositoryImpl from './ContratRepositoryImpl';

const contractRepository = new ContratRepositoryImpl(fetcherAmplify);

export { contractRepository };
